import { Component } from '@angular/core';

@Component({
  selector: 'app-carousel-title',
  standalone: true,
  imports: [],
  templateUrl: './carousel-title.component.html',
  styleUrl: './carousel-title.component.scss'
})
export class CarouselTitleComponent {

}
